import dayjs from 'dayjs';
import { Tag } from 'antd';
import styles from './workers_icon.module.scss';
import { Robot, Worker } from '../../../model/workers_response';
import { BusinessType } from '../../../valueobject/business_type';
import {BusinessTypes, getEnumByKey, RobotTypeKeys, RobotTypes, WorkerStatus} from '../../../constant';

export const RobotDetail : React.FC<{ robot: Robot }> = ({ robot }) => {
  return (
        <div>
            <div className={styles.description}>
                <table>
                  <tbody>
                  <tr>
                    <th>ロボットID</th>
                    <td>{robot.robotId}</td>
                  </tr>
                  <tr>
                    <th>サービスタイプ</th>
                    <td>{RobotTypes.find((type) => type.key === robot.type)?.value ?? ''}</td>
                  </tr>
                  <tr>
                    <th>ロボット名</th>
                    <td>{robot.name}</td>
                  </tr>
                  <tr>
                    <th>モデル名</th>
                    <td>{robot.model}</td>
                  </tr>
                  <tr>
                    <th>動作状態</th>
                    <td>{robot.status.operationState}</td>
                  </tr>
                  <tr>
                    <th>ステータス</th>
                    <td>
                      {robot.status.isOnline ? <Tag color={'#6af'}>オンライン</Tag> :
                        <Tag color={'#999'}>オフライン</Tag>}
                      {robot.status.emergency ? <Tag color={'#f50'}>緊急</Tag> : null}
                      {robot.status.isCharging ? <Tag color={'#fa6'}>充電中</Tag> : null}
                      {robot.status.brake ? <Tag color={'#ccf'}>ブレーキ</Tag> : null}
                      {robot.status.manual ? <Tag color={'#f90'}>マニュアル走行</Tag> : null}
                      {robot.status.ad ? <Tag color={'#6c6'}>自律走行</Tag> : null}
                    </td>
                  </tr>
                  <tr>
                    <th>バッテリー残量</th>
                    <td>
                      {robot.status.remainingBattery === 0
                      ? "-"
                      : `${robot.status.remainingBattery}%`}
                    </td>
                  </tr>
                  <tr>
                    <th>スピード</th>
                    <td>
                      {robot.status.speedMps === 0
                        ? "-"
                        : `${robot.status.speedMps}m/s`
                      }
                    </td>
                  </tr>
                  <tr>
                    <th>同期日時</th>
                    <td>{dayjs(robot.syncedAt)
                      .format('YYYY/MM/DD HH:mm:ss')}</td>
                  </tr>
                  </tbody>
                </table>
            </div>
        </div>
  );
};

export const WorkerDetail: React.FC<{ worker: Worker }> = ({worker}) => {
  // TODO: あとで共通化
  const businessTypeKey = () => {
    switch (worker.businessType) {
      case BusinessType.cleaning:
        return '清掃';
      case BusinessType.greening:
        return '植栽';
      case BusinessType.equipment:
        return '設備';
      default:
        return '無し';
    }
  };

  const status = () => {
    switch (worker.status) {
      case WorkerStatus.WORKING:
        return <Tag color={'#66ccff'}>作業中</Tag>;
      case WorkerStatus.EMERGENCY:
        return <Tag color={'#ff6666'}>緊急</Tag>;
      case WorkerStatus.BREAK:
        return <Tag color={'#999999'}>休憩中</Tag>;
      default:
        return <Tag color={'#cc6666'}>不明</Tag>;
    }
  };

  return (
      <div>
          <div className={styles.description}>
              <table>
                  <tbody>
                  <tr>
                      <th>端末ID</th>
                      <td>{worker.deviceId}</td>
                  </tr>
                  <tr>
                      <th>業務種別</th>
                      <td>{businessTypeKey()}</td>
                  </tr>
                  <tr>
                      <th>ステータス</th>
                      <td>{status()}</td>
                  </tr>
                  <tr>
                      <th>同期日時</th>
                      <td>{dayjs(worker.syncedAt).format('YYYY/MM/DD HH:mm:ss')}</td>
                  </tr>
                  </tbody>
              </table>
          </div>
      </div>
  );
};
